export function cleanPrice(priceString: string): string {
    // Remove everything except digits and a point
    return priceString.replace(/[^0-9.]/g, '');
  }
  
  export function priceStringToCents(priceString: string): number {
    const cleanedString = cleanPrice(priceString);
    // For simplicity, assume that if there's a comma and it's followed by two digits at the end, it's a decimal separator.
    const normalized = cleanedString.includes(',') && /^.*,\d{2}$/.test(cleanedString)
      ? cleanedString.replace(',', '.')
      : cleanedString;
    return Math.round(parseFloat(normalized) * 100);
  }
  